import { combineReducers } from 'redux'
import transactionsReducer from './transactions'
import recurringReducer from './recurring'
import mcpReducer from './mcp'
import commonReducer from './common'
import vault from './vault'
import vaultFinancial from './vaultFinancial'
import threeDSTwoReducer from './threeDSTwo'
import checkoutReducer from './checkout'

// import mco3ds2Reducer from '../mco-3ds2/reducers'


export default combineReducers({
    common: commonReducer,
    transactions: transactionsReducer,
    recurring: recurringReducer,
    mcp: mcpReducer,
    vault:vault,
    vaultFinancial:vaultFinancial,
    threeDSTwo: threeDSTwoReducer,
    checkout: checkoutReducer,


    // mco3ds2: mco3ds2Reducer,
})